import React, { useEffect, useRef, useState } from "react";
import Attachment from "./Attachment";
import { useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";

const Attachments = ({defaultValue, types, single, onChange}) =>
{
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const inputFile = useRef(null);
	const [files, SetFiles] = useState([]);
	// const [files, SetFiles] = useState(defaultValue ? defaultValue : []);
	// useEffect(() => SetFiles(defaultValue ? defaultValue : []), [defaultValue]);
	const [firstLoad, SetFirstLoad] = useState(true);

	useEffect(() =>
	{
		if(defaultValue && defaultValue.length && firstLoad)
		{
			SetFiles(defaultValue);
			SetFirstLoad(false);
		}
	// eslint-disable-next-line
	}, [defaultValue]);

	useEffect(() =>
	{
		if(files && files.length && onChange)
		{
			onChange(files);
		}
	// eslint-disable-next-line
	}, [files]);

	const DropHandler = (e) =>
	{
		e.preventDefault();
		e.stopPropagation();
		if (e.dataTransfer.files && e.dataTransfer.files[0])
		{
		  FileHandler(e.dataTransfer.files);
		}
	}

	const FileHandler = async (selectedFiles) =>
	{
		try
		{
			if(single)
			{
				const info = [{
					'id': '',
					'name': selectedFiles[0].name,
					'url': '',
					'document_id': '',
					'document_name': selectedFiles[0].name,
					'type': language.ATTACHMENT,
					'deleted': false,
					'data': selectedFiles[0]
				}];
				SetFiles(info);
			}
			else
			{
				for(const file of selectedFiles)
				{
					const info = {
						'id': '',
						'name': file.name,
						'url': '',
						'document_id': '',
						'document_name': file.name,
						'type': '',
						'deleted': false,
						'data': file
					};
					SetFiles(files => [...files, info]);
				}
			}
		}
		catch (ex){}
	}
	
	const HandleChange = (key, data) =>
	{
		if(single)
		{
			if(data.deleted)
			{
				SetFiles([]);
			}
			else
			{
				SetFiles([data]);
			}
		}
		else
		{
			const temp = files.map((file, index) => (index === key) ? data.deleted ? {} : data : file);
			SetFiles(temp);
		}
	}
	
	return <>
		{single && files[0] && !files[0].deleted ? null : <div className="flex items-center gap-2 mb-3" onDrop={(e) => DropHandler(e)}>
		<label onClick={() => inputFile.current.click()} className='flex grow justify-between border-2 border-dashed rounded-lg border-primaryBorder mb-0 px-2 py-1 cursor-pointer hover:border-primary'>
			<div className='flex items-center gap-2'>
				<i className='fa fa-cloud-upload fa-3x text-primary'></i>
				<span className='hidden lg:block text-xs'>{language.DRAG_HERE}</span>
			</div>
			<div className='flex items-center gap-2'>
				<span className='hidden lg:block my-2 text-xs'>{language.OR}</span>
				<div className='btn secondary !mt-0 py-2'>{language.BROWSE_FILE}</div>
			</div>
		</label>
		</div>}
		<input ref={inputFile} type='file' className='hidden' onChange={(e) => FileHandler(e.target.files)} multiple={!single}/>
		{files && files.map((file, index) => <Attachment key={index} fileKey={index} types={types} info={file} onChange={(key, data) => HandleChange(key, data)}/>)}
	</>
}

export default Attachments;